import plainAxios from 'axios';

export const MAINTENANCE_QUERY_KEY = ['maintenance-status'];

// Public endpoint, so it deliberately skips the shared axios instance:
// its interceptors toast/logout on errors, which must not happen for a
// background poll. The mode itself is switched from ibbr-admin.
export async function fetchMaintenanceStatus() {
  const response = await plainAxios.get(
    `${process.env.REACT_APP_FAST_API}/configs/maintenance`,
    { timeout: 8000 }
  );
  return response.data.data;
}
